import { render, staticRenderFns } from "./VaultFiles.vue?vue&type=template&id=23f48cd2&scoped=true&"
import script from "./VaultFiles.vue?vue&type=script&lang=ts&"
export * from "./VaultFiles.vue?vue&type=script&lang=ts&"
import style0 from "./VaultFiles.vue?vue&type=style&index=0&id=23f48cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f48cd2",
  null
  
)

export default component.exports